const ASSETS = "/assets/";

export const IMAGE_PATHS = {
    CP_LOGO: ASSETS + "cp-logo.jpg",
    ABC_LOGO: ASSETS + "abc-logo.png",
    VCP_LOGO: ASSETS + "vcp-logo.png",
};